const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/lists/$id/items/$itemId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/lists/$id/items/$itemId/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/lists/$id/items/$itemId/")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    match,
    loaderData
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    const item = loaderData?.item;
    const fallback = tMeta("myLists");
    const title = item ? [item.title, item.artistNames].filter(Boolean).join(" - ") || fallback : fallback;
    return {
      meta: buildPrivatePageMetaTags(title)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});